import { api_GET, api_POST, api_PUT } from "api/axios.js";

const entradaindividual_api =
{
    getList: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`entradaindividual/List`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getItemFromFicha: function(localId, entradaindividualId){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`entradaindividual/${localId}/${entradaindividualId}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    relatorio: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`entradaindividual/relatorio`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    }, 
    post: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`entradaindividual`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },    
    put: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_PUT(`entradaindividual`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default entradaindividual_api
